import React, { createContext, useContext, useReducer } from 'react';
import { newsDetailReducer, initialState, INewsDetailState, Action } from './news-detail-reducer';

const NewsDetailStateContext = createContext<INewsDetailState | undefined>(undefined);
const NewsDetailDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const NewsDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(newsDetailReducer, initialState);

    return (
        <NewsDetailStateContext.Provider value={state}>
            <NewsDetailDispatchContext.Provider value={dispatch}>
                {children}
            </NewsDetailDispatchContext.Provider>
        </NewsDetailStateContext.Provider>
    );
};

export const useNewsDetailState = (): INewsDetailState => {
    const context = useContext(NewsDetailStateContext);
    if (!context) {
        throw new Error('useNewsDetailState must be used within NewsDetailProvider');
    }
    return context;
};

export const useNewsDetailDispatch = (): React.Dispatch<Action> => {
    const context = useContext(NewsDetailDispatchContext);
    if (!context) {
        throw new Error('useNewsDetailDispatch must be used within NewsDetailProvider');
    }
    return context;
};
